<mat-sidenav-container
  class="flex-fxflex-fill"
  [ngClass]="themeService.theme()"
  hasBackdrop="false"
>
  <mat-sidenav
    #sidenav
    mode="over"
    fixedInViewport="true"
    role="navigation"
    aria-label="Mobile navigation menu"
  >
    <mat-nav-list
      [ngClass]="themeService.theme()"
      class="flex-column flex-gap-20 flex-fxflex"
    >
      <a
        [ngClass]="{ 'link-active': isActive() }"
        (click)="closeSidenav()"
        routerLink="/home"
        routerLinkActive="link-active"
        mat-list-item
      >
        <span>
          <img alt="tehwolf.de" class="nav-logo" src="../../favicon.svg" />
          <span>{{ 'nav.home' | translate }}</span>
        </span>
      </a>
      <mat-divider></mat-divider>
      <h3 matSubheader class="nav-subheader">
        {{ 'nav.libraries' | translate }}
      </h3>
      <a
        (click)="closeSidenav()"
        routerLink="/portfolio"
        routerLinkActive="link-active"
        mat-list-item
      >
        <span>{{ 'nav.portfolio' | translate }}</span>
      </a>
      <a
        (click)="closeSidenav()"
        routerLink="/wordlist-generator"
        routerLinkActive="link-active"
        mat-list-item
      >
        <span>
          <span>{{ 'nav.wordlistGenerator' | translate }}</span>
        </span>
      </a>
      <a
        (click)="closeSidenav()"
        routerLink="/contact-form"
        routerLinkActive="link-active"
        mat-list-item
      >
        <span>
          <span>{{ 'nav.contactForm' | translate }}</span>
        </span>
      </a>
      <mat-divider></mat-divider>
      <h3 matSubheader class="nav-subheader">{{ 'nav.apps' | translate }}</h3>
      @for (app of apps; track app.slug) {
        <a
          (click)="closeSidenav()"
          [routerLink]="'/' + app.slug"
          routerLinkActive="link-active"
          mat-list-item
        >
          <span>{{ app.title }}</span>
        </a>
      }
      <mat-divider></mat-divider>
      <h3 matSubheader class="nav-subheader">{{ 'nav.links' | translate }}</h3>
      <a
        (click)="closeSidenav()"
        class="mat-mdc-list-item"
        target="_blank"
        href="https://github.com/tehw0lf"
        mat-list-item
      >
        <span>
          <img
            alt="tehwolf.de"
            class="nav-logo"
            src="assets/icons/github.png"
          />
          <span>{{ 'nav.github' | translate }}</span>
        </span>
      </a>
      <div>
        <button
          id="menu"
          type="button"
          (click)="toggleSidenav()"
          mat-icon-button
          [attr.aria-label]="'nav.closeMenu' | translate"
        >
          <mat-icon>menu</mat-icon>
        </button>
        @if (themeService.theme() === 'dark') {
          <button
            id="light"
            class="light-theme-button flex-gap-20"
            type="button"
            (click)="switchToLight()"
            mat-icon-button
            [attr.aria-label]="'nav.switchToLight' | translate"
          >
            <mat-icon>light_mode</mat-icon>
          </button>
        }
        @if (themeService.theme() === 'light') {
          <button
            id="dark"
            class="dark-theme-button flex-gap-20"
            type="button"
            (click)="switchToDark()"
            mat-icon-button
            [attr.aria-label]="'nav.switchToDark' | translate"
          >
            <mat-icon>dark_mode</mat-icon>
          </button>
        }
        <tehw0lf-language-switcher />
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content
    [ngClass]="themeService.theme()"
    class="main-content flex-fxflex-fill"
    (click)="closeSidenav()"
  >
    <main id="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
